function isObject(a) {
    return a && typeof a === "object" && !Array.isArray(a);
}
function extend(a, b) {
    for (const key in b) {
        const from = b[key];
        if (isObject(a[key]) && isObject(from)) {
            a[key] = extend({ ...a[key] }, b[key]);
        }
        else {
            a[key] = b[key];
        }
    }
    return a;
}
export function locale(words) {
    return {
        getGroup(group) {
            const block = words[group];
            return (key) => {
                return block ? block[key] || key : key;
            };
        },
        getRaw() {
            return words;
        },
        extend(values, optional) {
            if (!values)
                return this;
            let data;
            if (optional) {
                data = extend({ ...values }, words);
            }
            else {
                data = extend({ ...words }, values);
            }
            return locale(data);
        },
    };
}
//# sourceMappingURL=locale.js.map